import React, { Component } from 'react'
import JewelryPanel from '../jewelry-panel'
import Spacer from '../../../components/spacer'
import SelectItem from '../../../components/select-item'
import {
  hideShankTopDiamondMilgrain,
  jewelryTypeIsRing
} from '../../../utils/jewelry-validation'

class ShankTopDiamondPanel extends Component {
  render () {
    const props = this.props
    const getShankTopDiamondOptions = () => {
      let options = [
        {value: 'all', label: 'All Rows'},
        {value: 'single_row', label: 'Single Row', disabled: props.shank_type === 'single_row'},
        {value: 'two_rows', label: 'Two Rows', disabled: props.shank_type !== 'three_rows' && props.shank_type !== 'four_rows' && props.shank_type !== 'five_rows'},
        {value: 'three_rows', label: 'Three Rows', disabled: props.shank_type !== 'four_rows' && props.shank_type !== 'five_rows'},
        {value: 'four_rows', label: 'Four Rows', disabled: props.shank_type !== 'five_rows'}
      ]

      return options
    }

    const getShankTopDiamondShapeOptions = () => {
      let options = [
        {value: 'round', label: 'Round'},
        {value: 'princess', label: 'Princess', disabled: props.shank_shape !== 'straight' || props.shank_type === 'intertwined_rows' || props.shank_type === 'split_rows'}
      ]

      return options
    }

    const getShankTopSettingStyleOptions = () => {
      let options = [
        {value: 'pave', label: 'Pavé', disabled: props.shape_of_diamonds_down_top_of_shank === 'princess'},
        {value: 'pave_border', label: 'Pavé w/ Border', disabled: props.shape_of_diamonds_down_top_of_shank === 'princess'},
        {value: 'channel_set', label: 'Channel Set'},
        {value: 'bezel_set', label: 'Bezel Set'},
        {value: 'shared_claw_set', label: 'Shared Claw', disabled: props.shape_of_diamonds_down_top_of_shank === 'princess'}
      ]

      return options
    }
    return (
      <JewelryPanel
        id='shankTopDiamondPanelContainer'
        show={jewelryTypeIsRing(props)}
        isResetting={props.isResetting}>

        <Spacer lg />

        <SelectItem
          id='has_diamonds_down_top_of_shank'
          label='Diamonds Down Top of Shank?'
          labelId='shanktop'
          options={[
            {value: false, label: 'No'},
            {value: true, label: 'Yes'}
          ]}
          value={props.has_diamonds_down_top_of_shank}
          onChange={props.onChangeVal.bind(this, 'has_diamonds_down_top_of_shank')}
        />

        <JewelryPanel
          id='shankTopDiamondPanel'
          show={props.has_diamonds_down_top_of_shank}
          isResetting={props.isResetting}>

          <Spacer xxs />

          <SelectItem
            label='Diamonds Down Top of Shank'
            id='shankTopDiamonds'
            labelId='diamonds_down_top_of_shank'
            options={getShankTopDiamondOptions()}
            value={props.diamonds_down_top_of_shank}
            onChange={props.onChangeVal.bind(this, 'diamonds_down_top_of_shank')}
            initVal={null}
          />

          <Spacer xxs />

          <SelectItem
            id='distance_diamonds_down_top_of_shank'
            label='Distance of Diamonds Down Top of Shank'
            labelId='distance_diamonds_down_top_of_shank'
            options={[
              {value: 0.25, label: '1/4'},
              {value: 0.5, label: '1/2+1'},
              {value: 0.75, label: '3/4'},
              {value: 1.00, label: 'Eternity'}
            ]}
            value={props.distance_diamonds_down_top_of_shank}
            onChange={props.onChangeVal.bind(this, 'distance_diamonds_down_top_of_shank')}
            initVal={null}
          />

          <Spacer xxs />

          <SelectItem
            label='Shape of Diamonds Down Top of Shank'
            id='shankTopDiamondShape'
            labelId='shape_of_diamonds_down_top_of_shank'
            options={getShankTopDiamondShapeOptions()}
            value={props.shape_of_diamonds_down_top_of_shank}
            onChange={props.onChangeVal.bind(this, 'shape_of_diamonds_down_top_of_shank')}
            initVal={null}
          />

          <Spacer xxs />

          <SelectItem
            label='Quality of Diamonds Down Top of Shank'
            labelId='quality_of_diamonds_down_top_of_shank'
            id='shankTopDiamondQuality'
            options={[
              {value: 'standard', label: 'Standard'},
              {value: 'plus', label: 'Plus'},
              {value: 'lab_grown', label: 'Lab Grown'},
            ]}
            value={props.quality_of_diamonds_down_top_of_shank}
            onChange={props.onChangeVal.bind(this, 'quality_of_diamonds_down_top_of_shank')}
            initVal={null}
          />

          <Spacer xxs />

          <SelectItem
            label='Setting Style of Diamonds Down Top of Shank'
            labelId='setting_style_of_diamonds_down_top_of_shank'
            id='shankTopSettingStyle'
            options={getShankTopSettingStyleOptions()}
            value={props.setting_style_of_diamonds_down_top_of_shank}
            onChange={props.onChangeVal.bind(this, 'setting_style_of_diamonds_down_top_of_shank')}
            initVal={null}
          />

          <Spacer xxs hide={hideShankTopDiamondMilgrain(props)} />

          <SelectItem
            label='Milgrain Top of Shank'
            labelId='milgrain_top_of_shank'
            id='shankTopMilgrain'
            options={[
              {value: 'no', label: 'No'},
              {value: 'yes', label: 'Yes'}
            ]}
            value={props.milgrain_top_of_shank}
            onChange={props.onChangeVal.bind(this, 'milgrain_top_of_shank')}
            hide={hideShankTopDiamondMilgrain(props)}
            initVal={null}
          />
        </JewelryPanel>
      </JewelryPanel>
    )
  }
}

export default ShankTopDiamondPanel



// WEBPACK FOOTER //
// ./src/components/jewelry-search-filters/shank-top-diamond-panel/index.js